function openVideoPopup(videoUrl) {
    const popup = document.getElementById('videoPopup');
    const videoFrame = document.getElementById('videoFrame');
    
    // Extract video ID from various YouTube URL formats
    let videoId = '';
    if (videoUrl) {
      const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
      const match = videoUrl.match(regExp);
      videoId = (match && match[2].length === 11) ? match[2] : null;
    }
    
    if (videoId) {
      // Construct the embed URL with security parameters
      const embedUrl = `https://www.youtube.com/embed/${videoId}?autoplay=0&rel=0&modestbranding=1&showinfo=0`;
      videoFrame.src = embedUrl;
      popup.style.display = 'flex';
    }
  }
  
  function closeVideoPopup() {
    const popup = document.getElementById('videoPopup');
    const videoFrame = document.getElementById('videoFrame');
    videoFrame.src = '';
    popup.style.display = 'none';
  }
  
  // Close popup when clicking outside the video
  window.onclick = function(event) {
    const popup = document.getElementById('videoPopup');
    if (event.target == popup) {
      closeVideoPopup();
    }
  }